import Vue from 'vue';
import { clone } from 'lodash';

export default {
  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
  /**
   *
   * @param state
   * @param action
   * @param parent
   * @param child
   * @param payload
   */
  setProductProperty(state, {
    action, parent, child, payload,
  }) {
    state[action][parent][child] = payload;
  },

  /**
   *
   * @param state
   * @param action
   * @param parent
   * @param payload
   */
  setActionProperty(state, { action, parent, payload }) {
    state[action][parent] = payload;
  },

  /**
   *
   * @param state
   * @param action
   * @param parent
   * @param payload
   */
  setActionMultipleProperty(state, { action, parent, payload }) {
    state[action][parent] = { ...state[action][parent], ...payload };
  },

  /**
   *
   * @param state
   * @param action
   * @param parent
   * @param key
   * @param property
   * @param payload
   */
  setProductMultipleData(state, {
    action, parent, key, property, payload,
  }) {
    if (state[action][parent][key]) {
      if (state[action][parent][key][property]) {
        state[action][parent][key][property] = payload;
      } else {
        state[action][parent][key] = { ...state[action][parent][key], ...{ [property]: payload } };
      }
    } else {
      Vue.set(state[action][parent], key, { [property]: payload });
    }
  },

  /**
   *
   * @param state
   * @param action
   * @param parent
   * @param key
   * @param index
   */
  removeProductMultipleData(state, {
    action, parent, key, index,
  }) {
    const objectLen = Object.keys(state[action][parent]).length;
    Vue.delete(state[action][parent], key);

    if (key < objectLen - 1) {
      for (let i = index; i < objectLen; i++) {
        const replace = clone(state[action][parent][i]);
        Vue.delete(state[action][parent], i);

        Vue.set(state[action][parent], i - 1, replace);
      }
    }
  },

  /**
   *
   * @param state
   * @param action
   * @param parent
   */
  resetProductMultipleData(state, { action, parent }) {
    state[action][parent] = {};
  },
};
